import ApplicationController from "../application_controller";

declare global {
  interface Window {
    rewardful?: (action: string, ...args: any[]) => void;
  }
}

// https://developers.rewardful.com/javascript-api/overview#specify-traffic-source
export default class RewardfulAttributionController extends ApplicationController {
  static values = { referralToken: String };

  declare referralTokenValue: string;

  initialize() {
    if (window.rewardful) {
      window.rewardful("source", this.referralTokenValue);
    }
  }
}
